export default "__VITE_ASSET__7ca78451__"